import * as v from "valibot";

export const RequestSchema = v.object({
  Action: v.nullish(v.string()),
  RoleName: v.nullish(v.string()),
  Version: v.nullish(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

export const ErrorClassSchema = v.object({
  Code: v.nullish(v.string()),
  Message: v.nullish(v.string()),
});
export type ErrorClass = v.InferOutput<typeof ErrorClassSchema>;

export const ResponseSchema = v.object({
  Data: v.record(v.string(), v.any()),
  Error: v.nullish(ErrorClassSchema),
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
